/**
 * Module Federation Async Boundary
 * ---
 * This dynamic import ensures that the entry point runs asynchronously.
 * This is required to avoid the "Shared module is not available for eager consumption" error
 * for any shared modules in the Module Federation configuration.
 */

import('./bootstrap')
